/**
 * Update notification settings via AJAX
 *
 * @param {Object} settings - Key-value pairs of notification settings
 * @returns {Promise<Object>} Response data
 */
export async function updateNotiSettings(settings) {
	const form = new FormData();
	form.append('action', 'update_noti_settings');
	form.append('nonce', wpcore.nonce);

	Object.entries(settings).forEach(([key, value]) => {
		form.append(`noti_settings[${key}]`, value);
	});

	const response = await fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: form,
	});

	return response.json();
}
